import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import useFormattedDate from '../../hooks/useFormattedDate';

import Button from '../buttons/Button';
import Title from '../typography/Title';

import styles from '../../../styles/cards/screening.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    vertical: PropTypes.bool,
    getUrlFromItem: PropTypes.func,
    className: PropTypes.string,
};

function ScreeningCard({ item = null, vertical = false, getUrlFromItem = null, className = null }) {
    const { locale } = useIntl();
    const { startDate = null, url = null, venues = null, films = null } = item || {};
    const { full: fullDate = null } = useFormattedDate(startDate, locale);

    const finalUrl = useMemo(
        () => (getUrlFromItem !== null ? getUrlFromItem(item) : url),
        [url, getUrlFromItem],
    );

    const filmNames = useMemo(
        () =>
            (films || []).reduce((acc, film) => {
                const { title: filmTitle = null } = film || {};
                if (filmTitle !== null) {
                    return `${acc}${acc.length > 0 ? ' + ' : ''}${filmTitle}`;
                }
                return acc;
            }, ''),
        [films],
    );

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles.vertical]: vertical,
                    [className]: className !== null,
                },
            ])}
            href={finalUrl}
        >
            <div className={styles.space}>
                {/* <Title className={styles.super} size="small">
                    {title}
                </Title> */}
                {venues !== null && venues.length > 0
                    ? venues.map((venue) => (
                          // eslint-disable-next-line react/jsx-indent
                          <Title key={`venue-${venue?.id}`} className={styles.venue} size="medium">
                              {venue?.nameWithCity}
                          </Title>
                      ))
                    : null}
                <Title className={styles.title} size="large">
                    {filmNames}
                </Title>
                <Title className={styles.date} size="medium">
                    {fullDate}
                </Title>
            </div>
        </Button>
    );
}

ScreeningCard.propTypes = propTypes;

export default ScreeningCard;
